import { getConfigsMFEFirebase } from '../../../helpers/mfeConfisFirebase'
import { CompanyId } from '../../../models/company-id'
import { CountryId } from '../../../models/country-id'
import { TENANT_ID } from '../tenantId'
import { getDefault } from './defaultConfigs'

export const getNaturaArgentina = () => ({
  ...getDefault(),
  tenantId: TENANT_ID.NATURA_ARGENTINA,
  country: {
    alpha2Code: CountryId.ARGENTINA,
    alpha3Code: 'ARG',
    language: 'es',
  },
  company: {
    name: 'NATURA',
    id: CompanyId.NATURA,
    logout: {
      buttonLinkHref: '/login?country=ARG&company=NATURA',
      externalLink: false,
    },
  },
  showEditButtonDetails: true,
  redirectUrlToLogin: {
    url: async () => getConfigsMFEFirebase('HOSTED_UI_AUTHENTICATION_URL'),
    clientId: async () => getConfigsMFEFirebase('CLIENT_ID_COGNITO'),
  },
})
